<template>
  <div>
    <div class="row">
      <div class="spacer"></div>
      <div class="column small-12">
        <h2 class=" animated wow fadeIn">Kontakt</h2>
        <br>
        <GmapMap :center="center" :zoom="17" map-type-id="roadmap">
          <GmapMarker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :clickable="true"
            :draggable="true"
            @click="center=m.position"
          />
        </GmapMap>
        <br>
        <h3 class=" animated wow fadeIn" data-wow-delay="300ms">Jaworzno, ul. Wapienna 3/1</h3>
        <p class="afterH2 animated wow fadeIn" data-wow-delay="300ms">Zapraszam do kontaktu telefonicznego lub mailowego w celu ustalenia indywidualnych godzin kursu lub korepetycji.</p>
      </div>
      <div class="spacer"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {      
      center: { lat: 50.211198, lng: 19.274747 },
      markers: [
        {
          position: { lat: 50.211198, lng: 19.274747 }
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../myVariables.scss';

iframe,
.vue-map-container {
  width: 100%;
  height: 420px !important;
  margin: 25px 0;
  padding: 0 25px;

  // @media (max-width: map-get($breakpoints, large ) - 1) {
  //   width: calc(100% - 50px) !important;
  //   margin: 25px;
  // }
}
.afterH2{
  text-align: left;
}
</style>